import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { environment } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ServicosGeraisService {

  constructor(
    private http: HttpClientService
  ) { }

  getComunicado(localExibicao: any, tipoPortal: any): Promise<any> {
    return this.http.getToDocument(environment.apiAdmin + '/mod-admin?localExibicaoMensagemComunicado=' + localExibicao + '&tipoPortal=' + tipoPortal)
    .toPromise().then(
      response => response
    )
  }

}
